import React, { useRef, useEffect } from "react";
import PropTypes from "prop-types";
import "./Modal.css"; // Ensure the CSS file is included

const Modal = ({ show, title, setShowModal, children, headerAction }) => {
  const modalRef = useRef(null);

  const handleOverlayClick = () => {
    setShowModal(false);
  };

  useEffect(() => {
    if (!show) return;
    const handleEscape = (keyEvent) => {
      if (keyEvent.key === "Escape") {
        setShowModal(false);
      }
    };
    document.addEventListener("keydown", handleEscape);
    return () => document.removeEventListener("keydown", handleEscape);
  }, [show, setShowModal]);

  if (!show) return null;

  return (
    <div className="modal-overlay">
      <button
        type="button"
        className="modal-overlay-button"
        onClick={handleOverlayClick}
        aria-label="Close modal"
      />
      <dialog
        ref={modalRef}
        open
        className="modal-content"
        aria-labelledby="modal-title"
        tabIndex={-1}
        style={{ position: "absolute", cursor: "grab" }}
      >
        <div className="modal-header-row">
          <div id="modal-title" className="modal-title">{title}</div>
          {headerAction ? (
            <div className="modal-header-action">{headerAction}</div>
          ) : (
            <button
              className="modal-cross-button"
              onClick={handleOverlayClick}
              aria-label="Close modal"
            >
              &times;
            </button>
          )}
        </div>
        <div className="modal-body">{children}</div>
      </dialog>
    </div>
  );
};

Modal.propTypes = {
  show: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  setShowModal: PropTypes.func.isRequired,
  children: PropTypes.node,
  headerAction: PropTypes.node,
};

Modal.defaultProps = {
  children: null,
  headerAction: null,
};

export default Modal;
